import { Outlet, useParams } from "react-router";
import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import {
  TabsNav,
  TabsNavContent,
  TabsNavLink,
  TabsNavList,
} from "@/shared/components/layout/tabs-nav";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { useShowCompanyQuery } from "@/services/backend/company/api/company";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { DeleteCompanyDialog } from "../list/_components/delete-company-dialog";

export function CompanyRoute() {
  const { companyId } = useParams();
  const { data: company, error } = useShowCompanyQuery({ id: companyId! });

  return (
    <PersistenceContextProvider>
      <BaseDataPage>
        <BaseDataPageHeader>
          <BaseDataPageTitle>
            <span>
              {t("Unternehmen")} {company?.name}
            </span>
            <PersistenceStateUsingContext />
          </BaseDataPageTitle>
        </BaseDataPageHeader>
        <BaseDataPageContent>
          {error && <RTKQueryErrorAlert error={error} />}
          <TabsNav>
            <div className="flex justify-between">
              <TabsNavList>
                <TabsNavLink to="data">{t("Stammdaten")}</TabsNavLink>
                <TabsNavLink to="profile">{t("Profil")}</TabsNavLink>
                <TabsNavLink to="pdf">{t("PDF-Template-Daten")}</TabsNavLink>
              </TabsNavList>
              {company && <DeleteCompanyDialog company={company} />}
            </div>
            <TabsNavContent className="pt-2">
              <Outlet />
            </TabsNavContent>
          </TabsNav>
        </BaseDataPageContent>
      </BaseDataPage>
    </PersistenceContextProvider>
  );
}
